exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".microphone[data-v-8ef35f0c]{display:block;width:32px;height:32px;margin:auto;text-decoration:none}\n", ""]);
